<div class="container">
    <div class="row pt-5">
        <div class="col text-center mt-5">
            <h2>Merry Christmas (Part 4)!</h2>
        </div>
    </div>
</div>
<div class="container">
    <div class="row pt-3">
        <div class="col text-center">
            <h4>You did it!</h4>
            <img class="img-fluid" src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWVsbzk5Mm01cHo3Yjc4MjRlZG56NmE2bWxqbWxrZ3F1c2Z1dm1pbyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/3otPoS81loriI9sO8o/giphy.gif" alt="">
            <p>Your mother and I are so proud 🥹</p>
            <p>Now ask your brother for the keys to his car, your present is in the back.</p>
        </div>
    </div>
</div>